const production = {
    url: 'https://stockmaid.com'
};
const development = {
    url: 'http://dev.stockmaid.com:8081'
};
export const config = process.env.NODE_ENV === 'development' ? development : production;